import { RedirectToSignIn, useSession } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../Components/Loading.jsx';

const Login = () => {
  const { isLoaded, isSignedIn } = useSession();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectUrl = params.get('redirect_url') || '/auth/dashboard';

  // Extract Clerk ticket parameters if present
  const clerkStatus = params.get('__clerk_status');
  const clerkTicket = params.get('__clerk_ticket');

  // If Clerk ticket parameters exist, need to preserve them for auth
  let finalRedirectUrl = redirectUrl;
  if (clerkStatus && clerkTicket) {
    const redirectParams = new URLSearchParams();
    redirectParams.set('__clerk_status', clerkStatus);
    redirectParams.set('__clerk_ticket', clerkTicket);
    finalRedirectUrl = `${redirectUrl}?${redirectParams.toString()}`;
  }

  if (!isLoaded) return <Loading />;
  if (isSignedIn) return <Navigate to={finalRedirectUrl} />;

  // Make sure to pass both redirectUrl and afterSignInUrl for complete flow
  return <RedirectToSignIn redirectUrl={redirectUrl} afterSignInUrl={redirectUrl} />;
};

export default Login;
